class CustomSelect extends BaseElement
{
  constructor ()
  {
    super();

    this.selectElement = this.querySelector('select');
    this.labelElement = this.querySelector('label');
    this.beforeElement = this.querySelector('.custom-select-before');
    this.afterElement = this.querySelector('.custom-select-after');
    this.wrapperDiv = null;
    this.valueDiv = null;
    this.labelDiv = null;
    this.bodyDiv = null;
    this.optionsDiv = null;
    this.searchDiv = null;
  }

  init ()
  {
    this.wrap();
    this.update();
    this.inputEvent = new Event("input");
    this.selectEvent = new Event("change");

    this.addEventListener('input', e => {
      const form = this.closest('form');

      if (form) {
        form.dispatchEvent(new Event('input'));
      }
    });

    this.addEventListener('change', e => {
      this.selectElement.dispatchEvent(this.selectEvent);
      this.update();
    });

    document.addEventListener('click', e => {
      this.close();
    });

    this.wrapperDiv.addEventListener('click', e => {
      e.stopPropagation();
    });

    this.selectElement.addEventListener('change', e => {
      this.update();
    });

    this.selectElement.addEventListener('modified', e => {
      this.refresh();
    });

    setTimeout(() => {
      this.update()
    }, 100);
  }

  toggle ()
  {
    if (this.wrapperDiv.classList.contains('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open ()
  {
    this.wrapperDiv.classList.add('open');

    const selectedOption = this.optionsDiv.querySelector('.selected');

    if (selectedOption && selectedOption.previousElementSibling) {
      this.optionsDiv.scrollTop = selectedOption.previousElementSibling.offsetTop;
    }
  }

  close ()
  {
    this.wrapperDiv.classList.remove('open');

    if (this.searchDiv) {
      const input = this.searchDiv.querySelector('input');
      input.value = '';
      input.dispatchEvent(new Event('change'));
    }
  }

  wrap ()
  {
    this.wrapperDiv = document.createElement('div');
    this.wrapperDiv.classList.add('custom-select');

    const classesToRemove = [];

    this.classList.forEach(name => {
      this.wrapperDiv.classList.add(name);
      classesToRemove.push(name);
    });

    classesToRemove.forEach(name => {
      this.classList.remove(name);
    });

    this.parentNode.insertBefore(this.wrapperDiv, this);
    this.wrapperDiv.appendChild(this);

    if (this.labelElement) {
      this.labelDiv = document.createElement('div');
      this.labelDiv.classList.add('custom-select-label');
      this.labelDiv.innerHTML = this.labelElement.innerHTML;
      this.wrapperDiv.appendChild(this.labelDiv);
    }

    this.valueDiv = document.createElement('div');
    this.valueDiv.classList.add('custom-select-value');

    this.valueContainerDiv = document.createElement('div');
    this.valueContainerDiv.classList.add('custom-select-value--container');
    this.valueContainerDiv.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      this.toggle();
    });

    if (this.beforeElement) {
      this.valueContainerDiv.appendChild(this.beforeElement);
    }

    this.valueContainerDiv.appendChild(this.valueDiv);

    if (this.afterElement) {
      this.valueContainerDiv.appendChild(this.afterElement);
    }

    this.wrapperDiv.appendChild(this.valueContainerDiv);

    const icon = document.createElement('div');
    icon.classList.add('custom-select-toggle');
    icon.innerHTML = this.getIcon();

    this.wrapperDiv.appendChild(icon);

    this.bodyDiv = document.createElement('div');
    this.bodyDiv.classList.add('custom-select-body');
    this.bodyDiv.addEventListener('click', e => e.stopPropagation());
    this.wrapperDiv.appendChild(this.bodyDiv);

    if (typeof(this.selectElement.dataset.search) !== 'undefined') {
      const placeholder = typeof(this.selectElement.dataset.searchPlaceholder) !== 'undefined'
        ? this.selectElement.dataset.searchPlaceholder
        : 'Search...';
      this.searchDiv = document.createElement('div');
      this.searchDiv.classList.add('custom-select-search');
      this.searchDiv.innerHTML = `<input type="text" placeholder="${placeholder}" /><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.125C15.899 2.125 19.875 6.10104 19.875 11C19.875 15.899 15.899 19.875 11 19.875C6.10104 19.875 2.125 15.899 2.125 11C2.125 6.10104 6.10104 2.125 11 2.125ZM11 18.125C14.936 18.125 18.125 14.936 18.125 11C18.125 7.06295 14.936 3.875 11 3.875C7.06296 3.875 3.875 7.06296 3.875 11C3.875 14.936 7.06295 18.125 11 18.125ZM18.2478 19.485L19.485 18.2478L22.1372 20.899L20.899 22.1372L18.2478 19.485Z" fill="currentColor" stroke="white" stroke-width="0.25"/></svg>`;
      ['change', 'keyup'].forEach(event => this.searchDiv.querySelector('input').addEventListener(event, e => this.search()));
      this.bodyDiv.appendChild(this.searchDiv);
    }

    this.optionsDiv = document.createElement('div');
    this.optionsDiv.classList.add('custom-select-options');
    this.bodyDiv.appendChild(this.optionsDiv);
    this.appendOptions();

    if (this.selectElement.disabled) {
      this.wrapperDiv.classList.add('custom-select-disabled');
    }
  }

  appendOptions ()
  {
    this.optionsDiv.innerHTML = '';

    if (this.selectElement.dataset.optionsSort) {
      const tmpAry = [];

      for (let i = 0; i < this.options.length; i++) {
        tmpAry[i] = [];
        tmpAry[i][0] = this.options[i].text;
        tmpAry[i][1] = this.options[i].value;
      }

      tmpAry.sort();

      while (this.options.length > 0) {
        this.options[0] = null;
      }

      for (let i = 0; i < tmpAry.length; i++) {
        this.options[i] = new Option(tmpAry[i][0], tmpAry[i][1]);
      }
    }

    for (let index = 0; this.selectElement.options.length > index; index++) {
      const option = document.createElement('div');
      option.classList.add('custom-select-option');
      this.selectElement.options[index].classList.forEach(cls => option.classList.add(cls));
      option.dataset.optionIndex = index;
      option.innerHTML = typeof(this.selectElement.options[index].dataset.optionHtml) !== 'undefined'
        ? this.selectElement.options[index].dataset.optionHtml
        : this.selectElement.options[index].innerHTML;

      if (this.selectElement.options[index].disabled) {
        option.classList.add('disabled');
      }

      if (typeof(this.selectElement.options[index].dataset.optionPlaceholder) !== 'undefined') {
        option.classList.add('placeholder');
      }

      option.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        if (option.classList.contains('disabled')) {
          return;
        }

        this.close();

        this.selectElement.value = this.selectElement.querySelectorAll('option')[index].value;
        this.dispatchEvent(new Event('input'));
        this.dispatchEvent(new Event('change'));
      });

      this.optionsDiv.append(option);
    }
  }

  search ()
  {
    const search = this.searchDiv.querySelector('input').value.toLowerCase();

    if (!search) {
      this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => option.classList.remove('hidden'));

      return;
    }

    this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => {
      if (option.textContent.toLowerCase().indexOf(search) > -1) {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    });
  }

  refresh ()
  {
    this.appendOptions();
  }

  update ()
  {
    this.optionsDiv.querySelectorAll('[data-option-index]').forEach(option => option.classList.remove('selected'));

    const option = this.optionsDiv.querySelector(`[data-option-index="${this.optionIndex || this.selectElement.options.selectedIndex}"]`);

    if (option) {
      option.classList.add('selected');

      const div = document.createElement('div');
      option.classList.forEach(cls => div.classList.add(cls));
      div.classList.remove('selected', 'custom-select-option');
      div.innerHTML = option.innerHTML;

      if (div.classList.length > 0) {
        this.valueDiv.innerHTML = '';
        this.valueDiv.appendChild(div);
      } else {
        this.valueDiv.innerHTML = option.innerHTML;
      }
    } else {
      this.valueDiv.innerHTML = '';
    }
  }

  filter (callback)
  {
    let option, div;

    for (let index = 0; this.selectElement.options.length > index; index++) {
      option = this.selectElement.options[index];
      div = this.optionsDiv.querySelector(`[data-option-index="${index}"]`);

      if (option) {
        if (callback(option, div)) {
          div.style.display = '';
        } else {
          div.style.display = 'none';
        }
      }
    }
  }

  getIcon ()
  {
    if (this.querySelector('.custom-select-icon')) {
      return this.querySelector('.custom-select-icon').innerHTML;
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M8.5 4L5.17678 7.32322C5.07915 7.42085 4.92085 7.42085 4.82322 7.32322L1.5 4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', CustomSelect);
}